export class Controller {

    /** @ngInject */
    constructor($rootScope, $state) {
        this.$rootScope = $rootScope;
        this.$state = $state;
    }

    $onInit() {
        this.breadcrumb = this.$rootScope.breadcrumbHistory.slice().reverse()
            .find((breadcrumb) => breadcrumb.name && !breadcrumb.name.startsWith(this.before));
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/sp-back/sp-back.controller.js